// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1350":"d74b410af2dc4f3e","3850":"bef55704f3278ac2","6962":"f3365c7204367b32","9961":"40e57e75df20e81f"}[chunkId] + ".css";
};